import * as React from 'react';

import './tab-order.styles.scss';

export type TabOrderProps = {
  value: number;
};

export const TabOrder: React.FC<TabOrderProps> = (props) => {
  const { value } = props;

  return (
    <div 
      className={"DatasheetsEditorDatasheetTabOrder"}
    >
      {value}
    </div>
  );
};